// Play each decorative SVG once when its card first enters the viewport.
if (!customElements.get('mabe-product-benefits')) {
  customElements.define('mabe-product-benefits', class extends HTMLElement {
    connectedCallback() {
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.setAttribute('data-motion-seen', '');
          this.observer.unobserve(entry.target);
        }
      }, { threshold: 0.35 });
      this.querySelectorAll('.mabe-benefit--animated:not([data-motion-seen])').forEach(card => this.observer.observe(card));
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
